import { useQuery, useQueryClient } from '@tanstack/react-query'
import { companyShiftDetailKey } from './keys'
import { getCompanyShiftDetailRest } from 'api/company'

export function useCompanyShiftDetail({
  companyId,
  shiftId,
}: {
  companyId: number
  shiftId: number
}) {
  return useQuery({
    queryKey: companyShiftDetailKey([shiftId]),
    queryFn: ({ signal }) =>
      getCompanyShiftDetailRest({ companyId, shiftId }, signal),
    refetchInterval: 60000, // refresh every 60s by default
  })
}

export function useInvalidateShiftDetail(ids: number[] | null) {
  const queryClient = useQueryClient()

  return {
    invalidate: () => {
      if (!ids || ids.includes(-1)) {
        // If ids are null or contain the fallback value (-1), don't proceed.
        return
      }
      queryClient.invalidateQueries({ queryKey: companyShiftDetailKey(ids) })
    },
  }
}
